import RenovationRibbon from "@/components/RenovationRibbon";

const RestaurantRenovationRibbon = () => (
  <RenovationRibbon
    translationBase="restaurant.renovationNotice"
    storageKey="restaurant-renovation-ribbon-dismissed-v2"
    gradientClassName="from-red-600 via-red-500/95 to-orange-500"
    ringOffsetClassName="focus:ring-offset-red-500"
    dataOid="restaurant-renovation-ribbon"
  />
);

export default RestaurantRenovationRibbon;
